import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Logout } from "Assets/vehicleIcon/logout.svg";
import { ReactComponent as Settings } from "Assets/sidebaricons/Settings.svg";
import styles from "./ModalUserProfile.module.scss";
import { gsap } from "gsap";
import { useAppDispatch } from "Redux/store";
import { logout } from "Redux/Auth/slice";
import { useNavigate } from "react-router";
import {
  SETTINGS_GENERAL_SETTING,
  SETTINGS_USER_PROFILE,
} from "Shared/Constants/routes";
import { readObj } from "Service/storage";
import { BullhornSvg } from "Assets";
import { Profile } from "Components/UI/Profile/Profile";
import { AnnouncementsModal } from "Components/Announcements/AnnouncementsModal/AnnouncementsModal";
import { useSelector } from "react-redux";
import { selectUnreadCount } from "Redux/Announcements/slice";

type ModalProps = {
  setOpen: (open: boolean) => void;
};

const ModalUserProfile: React.FC<ModalProps> = ({ setOpen }) => {
  const dispatch = useAppDispatch();
  const user = readObj("account");
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);
  const unreadAnnouncementsCount = useSelector(selectUnreadCount);
  const onAnnouncementsClick = () => {
    setIsOpen(true);
  };
  const handleLogout = () => {
    dispatch(logout());
  };

  const handleNavigateToUserProfile = () => {
    navigate(SETTINGS_USER_PROFILE);
  };

  const handleNavigateToGeneralSettings = () => {
    navigate(SETTINGS_GENERAL_SETTING);
  };

  const closeWithAnimation = () => {
    if (modalRef.current) {
      gsap.to(modalRef.current, {
        opacity: 0,
        scale: 0.8,
        y: -50,
        duration: 0.5,
        ease: "power3.in",
        onComplete: () => setOpen(false),
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        !isOpen
      ) {
        closeWithAnimation();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    if (modalRef.current) {
      gsap.fromTo(
        modalRef.current,
        { opacity: 0, scale: 0.8, y: -50 },
        { opacity: 1, scale: 1, y: 0, duration: 0.5, ease: "power3.out" }
      );
    }
  }, []);

  return (
    <>
      <div className={styles.content} ref={modalRef}>
        <div className={styles.content__absolute}>
          <div className={styles.content__absolute__userProfile}>
            <Profile className={styles.profile} />
            <p onClick={handleNavigateToUserProfile}>{user?.first_name}</p>
          </div>
          {(user?.contact?.is_administrator || user.is_owner) && (
            <div className={styles.content__absolute__userProfile}>
              <Settings width={"30"} height={"30"} />
              <p onClick={handleNavigateToGeneralSettings}>General Settings</p>
            </div>
          )}
          <div onClick={onAnnouncementsClick} className={styles.announcement}>
            <div className={styles.announcement__textWrapper}>
              <BullhornSvg width={"27"} height={"27"} />
              <h5>Announcements</h5>
            </div>
            {unreadAnnouncementsCount > 0 && (
              <div className={styles.announcement__count}>
                {unreadAnnouncementsCount}
              </div>
            )}
          </div>
          <div
            onClick={handleLogout}
            className={styles.content__absolute__logout}
          >
            <Logout height="27" width="27" />
            <p>Log Out</p>
          </div>
        </div>
      </div>
      {isOpen && (
        <AnnouncementsModal
          isOpen={isOpen}
          onClose={() => setIsOpen((prev) => !prev)}
        />
      )}
    </>
  );
};

export default ModalUserProfile;
